import { graphql } from "@/gql/__generated__";

export const monthlyRewards = graphql(`
  query MonthlyRewards($year: Int!) {
    monthlyRewards(year: $year) {
      date
      totalReward
      workCountExcludingWorkersCompensation
    }
    viewer {
      id
      totalRewardAmount
    }
  }
`);

export const pastEmployedTemporaryJobOffersQuery = graphql(`
  query PastEmployedTemporaryJobOffers($month: Int, $year: Int) {
    pastEmployedTemporaryJobOffers(month: $month, year: $year) {
      id
      isWorkersCompensation
      payrollReportStatus
      temporaryJobOffer {
        id
        title
      }
      payrollReport {
        id
        wageAmount
        transportExpenseAmount
        withholdingAmount
      }
      workCondition {
        id
        formatWorkDate
      }
      postedClientOffice {
        id
        name
      }
    }
  }
`);

export const kyashTransferSummaryQuery = graphql(`
  query KyashTransferSummary {
    kyashTransferSummary {
      availableAmount
      canApply
      unavailableReason
      confirmationToken
      nextAutoTransferDate
      bankAccount {
        bankName
        branchName
        accountType
        accountNumberLast4
        accountHolderName
      }
    }
  }
`);

export const kyashTransfersQuery = graphql(`
  query KyashTransfers($limit: Int, $offset: Int) {
    kyashTransfers(limit: $limit, offset: $offset) {
      id
      kind
      status
      amount
      requestedAt
    }
  }
`);

export const applyKyashTransferMutation = graphql(`
  mutation ApplyKyashTransfer($input: ApplyKyashTransferInput!) {
    applyKyashTransfer(input: $input) {
      kyashTransfers {
        id
      }
    }
  }
`);

export const PastEmployedTemporaryJobOfferFeedItemFields = graphql(`
  fragment PastEmployedTemporaryJobOfferFeedItemFields on TemporaryJobOfferFeedItem {
    temporaryJobOffer {
      id
      status
      title
    }
    id
    tags
    jobCategoryName
    officeName
    workDate
    perHourWage
    imageUrl
  }
`);
